import { Injectable } from '@angular/core';
import linkifyHtml from 'linkify-html';

export type LinkifyOptions = Parameters<typeof linkifyHtml>[1];

const DEFAULT_OPTIONS: LinkifyOptions = {
    defaultProtocol: 'https',

    attributes: {
        target: '_blank',
        rel: 'noopener',
        class: 'ba-link-linkout',
    },

    validate: {
        url: (value: string) => {
            return value.startsWith('http://') || value.startsWith('https://');
        },
        email: () => false
    }
};

@Injectable({ providedIn: 'root' })
export class LinkifyService {
    /**
     * Wandelt nur http/https URLs zu klickbaren <a>-Tags um.
     * Angular bindet das Ergebnis mit [innerHTML] und säubert automatisch.
     */
    linkify(input: string, options: LinkifyOptions = {}): string {
        return linkifyHtml(input, { ...DEFAULT_OPTIONS, ...options });
    }
}